<!-- A4 Landscape Container -->
<div class="a4-landscape-container"
  style="width: 100%; height: 100vh; overflow: hidden; background-color: #f5f5f5; padding: 10px;">
  <!-- Scrollable Content Area -->
  <div class="scrollable-content"
    style="width: 100%; height: calc(100vh - 80px); overflow: auto; background-color: white; border: 2px solid #ddd; border-radius: 8px; box-shadow: 0 4px 8px rgba(0,0,0,0.1);">

    <form [formGroup]="CommissionPayment">
      <!-- A4 Landscape Page -->
      <div id="print-section1" class="a4-landscape-page"
        style="width: 1123px; min-height: 794px; margin: 0 auto; padding: 20px; background-color: white; position: relative; border: 3px solid #000; padding: 15px; background-color: white; height: 100%;">

        <!-- Header -->
        <div class="header-section"
          style="border: 2px solid #000; padding: 10px; margin-bottom: 15px; display: flex; align-items: stretch; min-height: 120px;">
          <!-- Logo Section -->
          <div class="logo-section" style="flex: 0 0 20%; padding: 8px; display: flex; align-items: center;">
            <img style="max-width: 90%; height: auto; max-height: 80px;" src="../../../assets/img/brand/red.png"
              alt="Company Logo" />
          </div>

          <!-- Company Details Section -->
          <div class="company-details"
            style="flex: 0 0 60%; padding: 8px; text-align: center; border-left: 2px solid #000; border-right: 2px solid #000;">
            <div style="font-size: 24px; font-weight: bold; margin-bottom: 3px; line-height: 1.2;">हिंदुस्थान प्रकाशन
              संस्था</div>
            <div style="font-size: 12px; margin-bottom: 8px;">(Reg.No.-BOM-3/1961[GBBSD])</div>
            <hr style="margin: 8px 0; border: 1px solid #000;" />

            <div style="display: flex; text-align: left; gap: 15px; font-size: 10px;">
              <!-- Administrative Office -->
              <div style="flex: 1;">
                <div style="font-weight: bold; font-size: 11px; margin-bottom: 3px;">प्रशासकीय कार्यालय :</div>
                <div style="line-height: 1.3;">
                  116, 117, 118, 119, पहिला मजला,<br>
                  शिल्पीन सेंटर, 40, ग. द. आंबेकर मार्ग,<br>
                  वडाळा, मुंबई - 400031
                </div>
                <div style="font-size: 11px; margin-top: 3px;"><strong>दूरध्वनी :</strong> 9967570531</div>
              </div>

              <!-- Main Office -->
              <div style="flex: 1; border-left: 1px solid #000; padding-left: 10px;">
                <div style="font-weight: bold; font-size: 11px; margin-bottom: 3px;">मुख्य कार्यालय :</div>
                <div style="line-height: 1.3;">
                  5/12, कामत औद्योगिक वसाहत,<br>
                  396, स्वा. वीर सावरकर मार्ग,<br>
                  प्रभादेवी, मुंबई 400025.
                </div>
                <div style="font-size: 11px; margin-top: 3px;"><strong>दूरध्वनी :</strong> 24221440</div>
              </div>
            </div>
          </div>

          <!-- Title Section -->
          <div class="title-section"
            style="flex: 0 0 20%; padding: 8px; text-align: center; display: flex; align-items: center; justify-content: center;">
            <div style="font-size: 18px; font-weight: bold; line-height: 1.3;">जाहिरात<br>कमिशन पत्र</div>
          </div>
        </div>

        <!-- Table Section -->
        <table border="1" cellspacing="0" cellpadding="4"
          style="width: 100%; border: 2px solid #000; border-collapse: collapse; font-size: 10px; margin-bottom: 15px;">
          <thead>
            <tr>
              <th colspan="9"
                style="text-align: center; padding: 8px; background-color: #f0f0f0; font-size: 14px; font-weight: bold; border: 1px solid #000;">
                Advt Representative Commission
              </th>
            </tr>

            <!-- Representative Details -->
            <tr>
              <td colspan="4" style="text-align: left; padding: 10px; border: 1px solid #000; vertical-align: top;">
                <div style="line-height: 1.4;" *ngIf="getmodaldata && getmodaldata.length > 0">
                  <div style="font-size: 12px; font-weight: bold; margin-bottom: 2px;">{{ getmodaldata[0]?.rep_name }}
                  </div>
                  <div style="font-size: 10px; margin-bottom: 1px;">{{ getmodaldata[0]?.address }}</div>
                  <div style="font-size: 10px; margin-bottom: 1px;">{{ getmodaldata[0]?.taluka }}-{{
                    getmodaldata[0]?.pincode }}</div>
                  <div style="font-size: 10px;">मोबाईल-{{ getmodaldata[0]?.rep_mob_no }}</div>
                </div>
              </td>
              <td colspan="5"
                style="border: 1px solid #000; font-weight: bold; font-size: 12px; padding: 10px; text-align: center;">
                Commission No : {{ rcpt_no }}
              </td>
            </tr>

            <!-- Column Headers -->
            <tr style="background-color: #e8e8e8;">
              <th style="padding: 6px; border: 1px solid #000; text-align: center; width: 15%; font-size: 12px;">Advt
                Name</th>
              <th style="padding: 6px; border: 1px solid #000; text-align: center; width: 10%; font-size: 12px;">Invoice
                No</th>
              <th style="padding: 6px; border: 1px solid #000; text-align: center; width: 8%; font-size: 12px;">
                Invoice<br>Date</th>
              <th style="padding: 6px; border: 1px solid #000; text-align: center; width: 12%; font-size: 12px;">Issue
                Name</th>
              <th style="padding: 6px; border: 1px solid #000; text-align: center; width: 8%; font-size: 12px;">Issue
                Date</th>
              <th style="padding: 6px; border: 1px solid #000; text-align: center; width: 10%; font-size: 12px;">Net
                Amount</th>
              <th style="padding: 6px; border: 1px solid #000; text-align: center; width: 12%; font-size: 12px;">
                Received Amount</th>
              <th style="padding: 6px; border: 1px solid #000; text-align: center; width: 8%; font-size: 12px;">Comm %
              </th>
              <th style="padding: 6px; border: 1px solid #000; text-align: center; width: 10%; font-size: 12px;">Comm
                Amount</th>
            </tr>
          </thead>

          <!-- Table Body -->
          <tbody>
            <tr *ngFor="let row of getmodaldata; let i = index" style="page-break-inside: avoid;">
              <td
                style="padding: 4px; border: 1px solid #000; text-align: left; font-size: 12px; word-wrap: break-word; max-width: 120px;">
                {{ row.advt_name }}
              </td>
              <td style="padding: 4px; border: 1px solid #000; text-align: left; font-size: 12px;">{{
                row.advt_invoice_no }}</td>
              <td style="padding: 4px; border: 1px solid #000; text-align: center; font-size: 12px;">{{
                row.advt_invoice_date }}</td>
              <td style="padding: 4px; border: 1px solid #000; text-align: left; font-size: 12px;">{{ row.issue_name }}
              </td>
              <td style="padding: 4px; border: 1px solid #000; text-align: center; font-size: 12px;">{{ row.issue_date |
                date : "dd-MM-yyy" }}</td>
              <td style="padding: 4px; border: 1px solid #000; text-align: right; font-size: 12px;">{{ (row.amount *
                1).toFixed(2) }}</td>
              <td style="padding: 4px; border: 1px solid #000; text-align: right; font-size: 12px;">{{ (row.rcv_amt *
                1).toFixed(2) }}</td>
              <td style="padding: 4px; border: 1px solid #000; text-align: right; font-size: 12px;">{{
                row.comm_percentage }}</td>
              <td style="padding: 4px; border: 1px solid #000; text-align: right; font-size: 12px;">{{ (row.com_amt *
                1).toFixed(2) }}</td>
            </tr>
          </tbody>

          <!-- Table Footer -->
          <tfoot *ngIf="getmodaldata && getmodaldata.length > 0">
            <!-- Totals Row -->
            <tr style="font-weight: bold; background-color: #f5f5f5;">
              <td colspan="5" style="text-align: right; padding: 6px; border: 1px solid #000; font-size: 13px;">Total:
              </td>
              <td style="text-align: right; padding: 6px; border: 1px solid #000; font-size: 13px;">
                {{ (getTotalNetAmount() * 1).toFixed(2) }}
              </td>
              <td style="text-align: right; padding: 6px; border: 1px solid #000; font-size: 12px;">
                {{ (getTotalReceivedAmount() * 1).toFixed(2) }}
              </td>
              <td style="text-align: center; padding: 6px; border: 1px solid #000; font-size: 12px;">-</td>
              <td style="text-align: right; padding: 6px; border: 1px solid #000; font-size: 12px;">
                {{ ((totalCommission || 0) * 1).toFixed(2) }}
              </td>
            </tr>

            <!-- Summary Section -->
            <tr>
              <td colspan="5" style="text-align: right; padding: 4px; font-weight: bold;">TDS: {{
                getmodaldata[0]?.tds_percentage || 0 }}% - TDS
                Amount: </td>

              <td colspan="4" style="text-align: right; padding: 4px;font-weight: bold;"> {{
                ((getmodaldata[0]?.tds_amount) * 1).toFixed(2) }}
              </td>

            </tr>

            <!-- Round Off Amount -->
            <tr>
              <!-- Label -->
              <td colspan="4" style="text-align: right; padding: 4px; border: 1px solid #000; font-size: 12px;">
                Round Off:
              </td>

              <!-- Roundoff Remark -->
              <td colspan="3" style="text-align: left; padding: 4px; border: 1px solid #000; font-size: 12px;">
                {{ getmodaldata[0]?.round_off_remark || '-' }}
              </td>

              <!-- Roundoff Amount -->
              <td colspan="2"
                style="text-align: right; font-weight: bold; padding: 4px; border: 1px solid #000; font-size: 12px;">
                {{ (getmodaldata[0]?.round_off_amount ?? 0) | number:'1.2-2' }}
              </td>
            </tr>


            <!-- Net Payable Commission -->
            <tr>
              <td colspan="5"
                style="text-align: right; padding: 4px; font-weight: bold; background-color: #e8e8e8; border: 1px solid #000; font-size: 12px;">
                Net Payable Commission:</td>
              <td colspan="4"
                style="text-align: right; font-weight: bold; padding: 4px; background-color: #e8e8e8; border: 1px solid #000; font-size: 12px;">
                {{ (getNetPayableCommission() * 1).toFixed(2) }}
              </td>
            </tr>

            <!-- Payment Details Header -->
            <tr>
              <td colspan="9"
                style="text-align: center; font-size: 12px; padding: 6px; font-weight: bold; background-color: #f0f0f0; border: 1px solid #000;">
                Paid Commission Details
              </td>
            </tr>

            <!-- Payment Details Row -->
            <tr style="font-size: 11px;">
              <td style="padding: 6px; border: 1px solid #000; vertical-align: top;">
                <strong>Ac Name</strong><br />
                {{ getmodaldata[0]?.acc_name }}
              </td>

              <td style="padding: 6px; border: 1px solid #000; vertical-align: top;">
                <strong>Ac No</strong><br />
                {{ getmodaldata[0]?.account_no }}
              </td>

              <td style="padding: 6px; border: 1px solid #000; vertical-align: top;">
                <strong>Bank</strong><br />
                {{ getmodaldata[0]?.bank_name }}
              </td>

              <td style="padding: 6px; border: 1px solid #000; vertical-align: top;">
                <strong>IFSC</strong><br />
                {{ getmodaldata[0]?.ifsc_code }}
              </td>

              <td style="padding: 6px; border: 1px solid #000; vertical-align: top;">
                <strong>Branch</strong><br />
                {{ getmodaldata[0]?.branch }}
              </td>

              <td colspan="2" style="padding: 6px; border: 1px solid #000; vertical-align: top;">
                <strong>Voucher No</strong><br />
                {{ getmodaldata[0]?.voucher_no }}<br /><br />
                <strong>Cheque No</strong><br />
                {{ getmodaldata[0]?.cheque_no }}
              </td>

              <td colspan="2" style="padding: 6px; border: 1px solid #000; vertical-align: top;">
                <strong>Date</strong><br />
                {{ getmodaldata[0]?.com_paid_date }}
              </td>
            </tr>
          </tfoot>
        </table>

      </div>
    </form>

  </div>

  <!-- Footer Buttons -->
  <div class="button-container"
    style="text-align: center; padding: 15px; background-color: #f8f9fa; border-top: 1px solid #ddd;">
    <button class="noPrint no-print"
      style="margin-right: 15px; padding: 10px 25px; background-color: #007bff; color: white; border: none; border-radius: 5px; cursor: pointer; font-size: 14px;"
      mat-raised-button color="primary" printSectionId="print-section1" ngxPrint [useExistingCss]="true">
      🖨️ Print
    </button>
    <button class="no-print noPrint"
      style="padding: 10px 25px; background-color: #6c757d; color: white; border: none; border-radius: 5px; cursor: pointer; font-size: 14px;"
      (click)="closeexp()">❌ Close</button>
  </div>
</div>